import React from 'react';

import OrderDashboardContainer from 'containers/OrderDashboardContainer';

class OrdersDashboardPage extends React.Component {
	
	render() {
		return (
				<OrderDashboardContainer />
			);
		
	}
}


export default OrdersDashboardPage;


// WEBPACK FOOTER //
// ./src/pages/admin/OrdersDashboardPage.js